import React from 'react';
import { ITableDataSource } from 'models/table';
import { Grid, Typography } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import { Elabels } from 'pages/CaseManagementPage/CasesPage/helpers';
import { EButtonSizes, EButtonVariants } from 'constants/Buttons';
import Button from 'components/atoms/Button';
import { StyledTableCard, StyledTableCardItem } from '../../../styles';

interface IIntelligenceReportTableCard {
  data: ITableDataSource;
  viewAction: (id: string) => void;
  deleteAction: (id: string) => void;
  addReportResult: (id: string) => void;
  isReadOnly?: boolean;
  showAdd?: boolean;
}

export const IntelligenceReportTableCard = ({
  data,
  viewAction,
  deleteAction,
  addReportResult,
  isReadOnly,
  showAdd,
}: IIntelligenceReportTableCard) => {
  const { t } = useTranslations();

  return (
    <StyledTableCard container>
      <StyledTableCardItem size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.sourceSystem)}</Typography>
        <Typography variant="body2">{data.sourceSystem}</Typography>
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.trace)}</Typography>
        <Typography variant="body2">{data.trace}</Typography>
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.lastUpdate)}</Typography>
        <Typography variant="body2">{data.lastUpdate}</Typography>
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.lastAuthor)}</Typography>
        <Typography variant="body2">{data.lastAuthor}</Typography>
      </StyledTableCardItem>
      <StyledTableCardItem container size={{ xs: 12 }}>
        <Grid sx={{ mb: 1 }}>
          <Typography variant="subtitle2">{t(Elabels.actions)}</Typography>
        </Grid>
        <Grid container columnSpacing={2} sx={{ rowGap: 1 }}>
          <Grid size={{ xs: 12, sm: 4 }}>
            <Button
              variant={EButtonVariants.outlined}
              label={t('general.view.label')}
              onClick={() => viewAction(data.id.toString())}
              size={EButtonSizes.small}
              fullWidth
              id="intelligence_report_table_card_view-button"
            />
          </Grid>
          {!isReadOnly && showAdd && !data.fromTemplate && (
            <Grid size={{ xs: 12, sm: 4 }}>
              <Button
                variant={EButtonVariants.contained}
                label={t('general.delete.label')}
                onClick={() => deleteAction(data.id.toString())}
                size={EButtonSizes.small}
                fullWidth
                id="intelligence_report_table_card_delete-button"
              />
            </Grid>
          )}
          {!isReadOnly && showAdd && (
            <Grid size={{ xs: 12, sm: 4 }}>
              <Button
                variant={EButtonVariants.outlined}
                tableButton
                label={t(Elabels.addResults)}
                onClick={() => addReportResult(data.id.toString())}
                size={EButtonSizes.small}
                fullWidth
                id={`add_report_result-button-${data.id}`}
              />
            </Grid>
          )}
        </Grid>
      </StyledTableCardItem>
    </StyledTableCard>
  );
};
